import DOMPurify from "dompurify";

// Default, conservative config. Extend per-view as needed.
const defaultConfig = {
  ALLOWED_TAGS: ["b", "i", "em", "strong", "a", "u", "br"],
  ALLOWED_ATTR: ["href", "target", "rel"],
  ADD_ATTR: ["rel"],
};

export function sanitizeHtml(html, config = defaultConfig) {
  if (!html || typeof html !== "string") return html ?? "";
  return DOMPurify.sanitize(html, config);
}

export default sanitizeHtml;
